import { render } from "./PluginList.vue?vue&type=template&id=7e32e200"
import script from "./PluginList.vue?vue&type=script&lang=js"
export * from "./PluginList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__